/* CMI-S UI */
export const CONCURRENT_FILTER_TITLE = 'Concurrent requirements of';
export const SB_REF = 'SB Ref:';
export const MSN_AC_REG = 'MSN/AC-Reg:';
export const CONFIGURATION = 'Configuration:';
export const STATUS = 'Status:';
